import { db, auth, msgr } from '@/main'

export const Account = {
  data() {
    return {
      user: null,
      account: {},
      biz: {},
      srvs: [],
      prds: [],
      cats: [],
      csts: [],
      notifications: []
    }
  },
  
  firestore() {
    if ( this.account.id ) return {
      notifications: db.collection( 'notifications' ).where( 'for', '==', this.account.id ).orderBy( 'read' )
    }
  },

  watch: {
    account( cr, pr ) {
      if ( cr.merchant ) {
        this.$binding( 'biz', db.collection( 'businesses' ).doc( cr.upgraded.bid ) ).then( biz => {
          this.$binding( 'srvs', db.collection( 'services' ).where( 'business_id', '==', biz.id ) )
          this.$binding( 'prds', db.collection( 'products' ).where( 'business_id', '==', biz.id ) )
          this.$binding( 'cats', db.collection( 'catalogs' ).where( 'business_id', '==', biz.id ) )
          this.$binding( 'csts', db.collection( 'customers' ).where( 'business_id', '==', biz.id ) )
        })
      }

      if ( cr.id ) this.$binding( 'notifications', db.collection( 'notifications' ).where( 'for', '==', this.account.id ).orderBy( 'read' ) )
    }
  },

  created() {
    auth.onAuthStateChanged( user => {
      this.user = user
      if ( user ) {
        if ( [ 'onboarding', 'new-profile', 'sign-up', 'sign-up-friend', 'sign-up-link', 'sign-up-ref', 'admin', 'sign-up-cus' ].includes( this.$route.name ) ) return
        this.$binding( 'account', db.collection( 'accounts' ).doc( user.uid ) ).then( doc => {
          if ( this.$route.name == 'sign-in' ) this.$router.push({ name: doc.merchant ? 'dashboard' : 'welcome' })

          let allowable = [ 'onboarding', 'verify-email', 'new-profile', 'sign-up-phone' ]
          
          if ( !allowable.includes( this.$route.name ) ) {
            if ( !this.welcomed( doc ) )
              this.$router.push({ name: 'new-profile', params: { id: doc.id } })
            else if ( 
              user.email && 
              !user.emailVerified && 
              !allowable.includes( this.$route.name ) && 
              ![ 'facebook.com', 'phone', 'google.com' ].some( id => user.providerData.map( d => d.providerId ).includes( id ) )
            ) {
              this.$router.push({ name: 'verify-email', params: { id: this.account.id } })
            }
          }

          
          if ( this.$route.meta.requiresMerchant && !this.account.merchant ) this.$router.push({ name: 'not-found' })
          
          this.$i18n.locale = doc.locale
          msgr.requestPermission().then( () => {
            this.tokenize()                                    
            this.refresh()
            this.handlers()
          }).catch( err => {
            console.log( 'Unable to get permission to notify.', err )
          })
        })

        
      }
      else {
        if ( this.$route.meta.requiresAuth ) {
          this.$router.push('/sign-in')
        }
      }
    })
  }
}
